"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGION_CODE_TO_LISTING = exports.MAIN_FILTER_QUERY_PARAMS = exports.CHECKBOX_FILTER_QUERY_PARAMS = void 0;
var MAIN_FILTER_QUERY_PARAMS = exports.MAIN_FILTER_QUERY_PARAMS = Object.freeze({
  CATEGORY: 'category',
  PRODUCT: 'product',
  REGION: 'region',
  COUNTRY: 'country'
});
var CHECKBOX_FILTER_QUERY_PARAMS = exports.CHECKBOX_FILTER_QUERY_PARAMS = Object.freeze({
  NEWLY_RELEASED_APPS: 'showNewlyReleasedApps'
});
var REGION_CODE_TO_LISTING = exports.REGION_CODE_TO_LISTING = Object.freeze({
  NA: 'northAmerica',
  LA: 'latinAmerica',
  EMEA: 'emea',
  APA: 'asia'
});